import React from 'react';
import t from 'format-message';
var NoResultsIcon = function NoResultsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "162",
    height: "168",
    viewBox: "0 0 162 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M81 166c44.183 0 80-5.373 80-12 0-3.755-11.498-7.107-29.5-9.307h-101C12.498 146.893 1 150.245 1 154c0 6.627 35.817 12 80 12z",
    fill: "#152633",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.454 164.068c-1.934-2.944-3.481-6.25-4.607-9.904-7.128-23.132 11.963-53.951 40.532-59.244 28.569-5.293 54.05 16.227 58.529 40.406.582 3.141.739 6.154.504 9.029l-.04.446c-.723 7.49-4.125 14.031-9.627 19.438C94.5 167.5 54.5 166 36.454 164.068z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.318 166.147c13.974.04 28.436-.473 40.428-1.908 5.501-5.407 8.903-11.948 9.626-19.438l.04-.446c.236-2.875.079-5.888-.503-9.029-4.097-22.111-25.755-41.997-51.276-41.19 24.202.765 44.341 19.951 48.276 41.19.582 3.141.739 6.154.503 9.029l-.04.446c-.723 7.49-4.125 14.031-9.626 19.438-11.136 1.333-24.401 1.87-37.428 1.908z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.454 164.068c-1.934-2.944-3.481-6.25-4.607-9.904-7.128-23.132 11.963-53.951 40.532-59.244 28.569-5.293 54.05 16.227 58.529 40.406.582 3.141.739 6.154.504 9.029l-.04.446c-.723 7.49-4.125 14.031-9.627 19.438C94.5 167.5 54.5 166 36.454 164.068z",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.858 157.447c-.386-2.08 2.763-4.407 7.031-5.198 4.27-.791 8.042.254 8.428 2.334.385 2.079-2.763 4.406-7.032 5.197-4.27.791-8.042-.254-8.427-2.333z",
    fill: "#152633"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.947 165.5c8.06-4.233 14.06-15.449 12.12-25.921-2.543-13.727-13.183-26.06-21.96-24.434-4.369.809-8.98 5.073-12.24 11.445-3.297 6.447-4.592 13.928-3.473 19.968 1.561 8.425 6.105 15.207 11.606 18.503 5 .439 9.5.939 13.947.439z",
    fill: "#2D3B45",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.285 138.448c2.326.241 3.903 3.399 3.524 7.053-.38 3.654-2.572 6.42-4.897 6.179-2.325-.242-3.903-3.399-3.524-7.053.38-3.654 2.572-6.42 4.897-6.179z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.876 145.607c3.683 3.802 7.405 5.402 10.464 4.919.055-.008.106-.017.156-.026 2.185-.405 4.769-2.044 6.247-4.134 3.604-5.095 4.625-10.141 3.212-17.77-2.229-12.028-16.543-25.394-25.176-23.795-1.872.347-3.278 1.265-4.234 2.754-2.846 4.432-2.134 13.42 1.336 24.533 1.49 4.774 4.371 9.776 7.995 13.519z",
    fill: "#2D3B45",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.313 135.572c1.363 2.685 1.083 5.564-.625 6.431-1.709.868-4.198-.606-5.561-3.29-1.363-2.684-1.083-5.563.625-6.431 1.708-.867 4.198.606 5.561 3.29z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.11 125.296a19.05 19.05 0 0 1-5.031-1.854c-6.827-3.655-7.107-11.804-7.077-13.859.029-2.055.645-12.01 8.984-9.044 5.385 1.914 11.3 5.781 14.817 8.28a55.785 55.785 0 0 0-11.693 16.477z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.079 119.442a19.05 19.05 0 0 0 5.03 1.854A55.801 55.801 0 0 1 42.24 106.4c1.34.867 2.552 1.7 3.564 2.419a55.785 55.785 0 0 0-11.693 16.477 19.05 19.05 0 0 1-5.031-1.854c-3.453-1.849-5.23-4.846-6.141-7.623a12.088 12.088 0 0 0 4.14 3.623z",
    fill: "#28343D"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M34.11 125.296a19.05 19.05 0 0 1-5.031-1.854c-6.827-3.655-7.107-11.804-7.077-13.859.029-2.055.645-12.01 8.984-9.044 5.385 1.914 11.3 5.781 14.817 8.28a55.785 55.785 0 0 0-11.693 16.477z",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.803 103.513a16.721 16.721 0 0 1-2.152 2.085c-4.663-3.782-9.999-6.82-15.785-8.82 2.074-3.11 5.605-7.976 9.311-11.148 5.809-4.973 9.386 2.866 10.046 4.514.66 1.65 2.956 8.308-1.42 13.369z",
    fill: "#2D3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.651 101.598a16.738 16.738 0 0 0 2.152-2.085c2.552-2.951 2.835-6.446 2.496-9.174.739 1.927 2.724 8.293-1.496 13.174a16.721 16.721 0 0 1-2.152 2.085c-4.663-3.782-9.999-6.82-15.785-8.82a85.731 85.731 0 0 1 1.99-2.858 52.592 52.592 0 0 1 12.795 7.678z",
    fill: "#28343D"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M114.803 103.513a16.721 16.721 0 0 1-2.152 2.085c-4.663-3.782-9.999-6.82-15.785-8.82 2.074-3.11 5.605-7.976 9.311-11.148 5.809-4.973 9.386 2.866 10.046 4.514.66 1.65 2.956 8.308-1.42 13.369z",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "50",
    cy: "23.5",
    rx: "40",
    ry: "22.5",
    fill: "#fff",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32 11.92c4.118-.427 7.958-.64 11.52-.64 2.091 0 3.627.49 4.608 1.472.982.981 1.472 2.517 1.472 4.608v1.44c0 1.6-.32 2.816-.96 3.648-.64.853-1.76 1.557-3.36 2.112l-3.2 1.12v1.6h-5.76V22.8l7.52-2.72v-2.72c0-.49-.149-.875-.448-1.152-.277-.299-.768-.448-1.472-.448-1.28 0-2.944.064-4.992.192-2.026.128-3.669.224-4.928.288v-4.32zm4.32 17.28h5.76V34h-5.76v-4.8z",
    fill: "#152633"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "27",
    cy: "58",
    rx: "7",
    ry: "4",
    fill: "#fff",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "34",
    cy: "73",
    rx: "5",
    ry: "3",
    fill: "#fff",
    stroke: "#152633",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "46",
    cy: "82.5",
    rx: "4",
    ry: "2.5",
    fill: "#fff",
    stroke: "#152633",
    strokeWidth: "2"
  }));
};
import { Billboard } from '@instructure/ui-billboard';
var NoResults = function NoResults() {
  return /*#__PURE__*/React.createElement(Billboard, {
    message: t('To add or create outcomes, visit the Canvas outcomes page or contact your admin.'),
    heading: t('There are no outcomes'),
    headingAs: "h3",
    headingLevel: "h3",
    size: "small",
    hero: /*#__PURE__*/React.createElement(NoResultsIcon, null),
    margin: "medium"
  });
};
export default NoResults;